import { calendarDateTimeFromTimestamp, isInstantAfter, isInstantEqual, isNilOrEmpty } from '@rentguru/commons-utils';
import isNil from 'lodash/isNil';

export interface RestorableOrganization {
  id: string;
  createdAt: string;
  contactId?: string | null;
  pendingDeletion?: boolean | null;
}

export const isOrganizationPendingDeletion = (organization: { pendingDeletion?: boolean | null }): boolean =>
  organization.pendingDeletion ?? false;

export const filterOpenOrganizations = <T extends { pendingDeletion?: boolean | null }>(organizations: T[]): T[] =>
  organizations.filter((organization) => !isOrganizationPendingDeletion(organization));

const compareByCreationThenId = (left: RestorableOrganization, right: RestorableOrganization): number => {
  const leftCreatedAt = calendarDateTimeFromTimestamp(left.createdAt);
  const rightCreatedAt = calendarDateTimeFromTimestamp(right.createdAt);
  if (isInstantEqual(leftCreatedAt, rightCreatedAt)) {
    return left.id.localeCompare(right.id);
  }
  return isInstantAfter(leftCreatedAt, rightCreatedAt) ? 1 : -1;
};

export const pickOrganizationToRestore = <T extends RestorableOrganization>(
  organizations: T[],
  lastActiveOrganizationId: string | null
): T | undefined => {
  const provisionedOrganizations = filterOpenOrganizations(organizations).filter(
    (organization) => !isNilOrEmpty(organization.contactId)
  );
  const lastActiveOrganization = provisionedOrganizations.find(
    (organization) => organization.id === lastActiveOrganizationId
  );
  if (!isNil(lastActiveOrganization)) {
    return lastActiveOrganization;
  }
  const sortedOrganizations = [...provisionedOrganizations].sort(compareByCreationThenId);
  return sortedOrganizations[0];
};
